/**
 * RichTextEditor Constants
 * Centralized configuration for the Slate.js editor
 */

// Keyboard hotkeys for text formatting marks
export const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+shift+s': 'strikethrough',
};

// Block types that use list-item wrapper
export const LIST_TYPES = ['numbered-list', 'bulleted-list', 'dashed-list'];

// Text alignment options
export const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify'];

// Available text colors for the color picker (Google Docs inspired)
export const TEXT_COLORS = [
  { name: 'Black', value: '#000000' },
  { name: 'Dark Gray 4', value: '#434343' },
  { name: 'Dark Gray 3', value: '#666666' },
  { name: 'Dark Gray 2', value: '#999999' },
  { name: 'Dark Gray 1', value: '#b7b7b7' },
  { name: 'Gray', value: '#cccccc' },
  { name: 'Light Gray 1', value: '#d9d9d9' },
  { name: 'Light Gray 2', value: '#efefef' },
  { name: 'Light Gray 3', value: '#f3f3f3' },
  { name: 'White', value: '#ffffff' },
  { name: 'Red Berry', value: '#980000' },
  { name: 'Red', value: '#ff0000' },
  { name: 'Orange', value: '#ff9900' },
  { name: 'Yellow', value: '#ffff00' },
  { name: 'Green', value: '#00ff00' },
  { name: 'Cyan', value: '#00ffff' },
  { name: 'Cornflower Blue', value: '#4a86e8' },
  { name: 'Blue', value: '#0000ff' },
  { name: 'Purple', value: '#9900ff' },
  { name: 'Magenta', value: '#ff00ff' },
];

// Available highlight/background colors
export const HIGHLIGHT_COLORS = [
  { name: 'None', value: null },
  // Row 1 - Bright highlighters
  { name: 'Yellow', value: '#ffff00' },
  { name: 'Lime', value: '#00ff00' },
  { name: 'Cyan', value: '#00ffff' },
  { name: 'Magenta', value: '#ff00ff' },
  { name: 'Orange', value: '#ff9900' },
  // Row 2 - Pastel/soft colors (easier on eyes)
  { name: 'Light Yellow', value: '#fff2cc' },
  { name: 'Light Green', value: '#d9ead3' },
  { name: 'Light Cyan', value: '#d0e0e3' },
  { name: 'Light Blue', value: '#cfe2f3' },
  { name: 'Light Purple', value: '#d9d2e9' },
  // Row 3 - More pastels
  { name: 'Light Orange', value: '#fce5cd' },
  { name: 'Light Pink', value: '#ead1dc' },
  { name: 'Light Red', value: '#f4cccc' },
  { name: 'Light Gray', value: '#efefef' },
  { name: 'Light Teal', value: '#d0f0f0' },
];

// Markdown-style shortcuts for auto-formatting
export const SHORTCUTS = {
  '*': 'bulleted-list',
  '-': 'dashed-list',
  '+': 'bulleted-list',
  '>': 'block-quote',
  '#': 'heading-one',
  '##': 'heading-two',
  '###': 'heading-three',
  '[]': 'checklist',
  '[ ]': 'checklist',
  '[x]': 'checklist',
};

// All element types supported by the editor
export const ELEMENT_TYPES = {
  PARAGRAPH: 'paragraph',
  HEADING_ONE: 'heading-one',
  HEADING_TWO: 'heading-two',
  HEADING_THREE: 'heading-three',
  BLOCK_QUOTE: 'block-quote',
  NUMBERED_LIST: 'numbered-list',
  BULLETED_LIST: 'bulleted-list',
  DASHED_LIST: 'dashed-list',
  LIST_ITEM: 'list-item',
  CHECKLIST: 'checklist',
  LINK: 'link',
  TABLE: 'table',
  TABLE_ROW: 'table-row',
  TABLE_CELL: 'table-cell',
};

// Empty template for new editor instances
export const EMPTY_TEMPLATE = [
  {
    type: 'paragraph',
    children: [{ text: '' }],
  },
];
